import { Drawer, List, LoadingSkeleton } from '@boltenergy-be/design-system'
import { ReferralCodeTermsDrawerProps } from './/types'
import { useTranslation } from 'next-i18next/pages'
import { useGetActiveReferralActionQuery } from 'store/api/cms-api'
import { REFERRAL_AMOUNT_GIVE, REFERRAL_AMOUNT_RECEIVE } from 'features/referral/constants'
import { useGetLanguage } from 'hooks/useGetLanguage'

const ReferralCodeTermsDrawer = ({ referralCode, ...props }: ReferralCodeTermsDrawerProps) => {
  // i18n
  const { t } = useTranslation('simulation')
  const language = useGetLanguage()

  // RTK Queries
  const { data, isLoading } = useGetActiveReferralActionQuery(
    { locale: language, replaceNameBy: referralCode?.referrer?.firstName },
    { skip: true /** !props.isOpen */ } // Skipped because there is no active referral action
  )

  // Constants
  const amountGive = data?.reduction || REFERRAL_AMOUNT_GIVE
  const amountReceive = data?.reduction || REFERRAL_AMOUNT_RECEIVE

  return (
    <Drawer title={t(($) => $.terms.referral.title)} serifTitle {...props}>
      <section className="flex-col gap-400">
        {isLoading ? (
          <LoadingSkeleton>
            <LoadingSkeleton.Paragraph lines={2} />
          </LoadingSkeleton>
        ) : (
          <p>{t(($) => $.terms.referral.description, { amountGive, amountReceive })}</p>
        )}

        <List as="ul">
          {t(($) => $.terms.referral.bullets, { returnObjects: true }).map((bullet, index) => (
            <li key={`bullet-${index}`}>{bullet}</li>
          ))}
        </List>
      </section>
    </Drawer>
  )
}

export default ReferralCodeTermsDrawer
